module.exports = __webpack_public_path__ + "static/img/banner-chuang.a7c11cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongBrand/banner-chuang.jpg
// module id = cN0k
// module chunks = 0